import { createAction } from "@reduxjs/toolkit";
import { DamType } from "src/types/damType";

export const DAM_TYPES_GET_ALL = createAction<{ damTypes: DamType[] }>("@damTypes/GET_ALL");
export const DAM_TYPES_GET_BY_ID = createAction<{ damType: DamType }>("@damTypes/GET_BY_ID");
export const DAM_TYPES_ADD = createAction<{ damType: DamType }>("@damTypes/ADD");
export const DAM_TYPES_UPDATE = createAction<{ damType: DamType }>("@damTypes/UPDATE");
export const DAM_TYPES_DELETE = createAction<{ damTypeId: string }>("@damTypes/DELETE");
